<template>
    <div class="vs-row flex items-center">
        <vs-col style="text-align: center;">
            <div class="row">
                <div class="vx-col w-full flex justify-center">
                    <!--            <a class="cursor-pointer flex items-center justify-center p-2" style="border-bottom: 1px solid rgb(84,93,167);color: rgb(84,93,167);">-->
                    <!--                Компонент по выбору-->
                    <!--            </a>-->
                    <template  v-for="cicle in cicles">
                        <a
                            v-if="cicle.short_name == 'ИА'"
                            class="button-component cursor-pointer flex items-center justify-center p-2 mx-1"
                            :class="{
                                    'new_selected':cicle.cycle == select_cycle,
                                    'new_no_selected':cicle.cycle != select_cycle
                            }"
                            @click="fetchComponent(cicle.cycle,true)">
                            <div class="lg">
                                <div v-if="cicle.name==null||cicle.name==''">
                                    <p style="font-weight: 600;" v-if="cicle.short_name==null||cicle.short_name==''">
                                        {{ $t('without_cycle') }}
                                    </p>
                                    <p style="font-weight: 600;font-size: 12px;" v-else>
                                        {{cicle.name.slice(0,2).toUpperCase()}}
                                    </p>
                                </div>
                                <div v-else>
                                    <p style="font-weight: 600;">
                                        {{cicle.name}}
                                    </p>
                                </div>
                            </div>
                            <div class="xs">
                                <div v-if="cicle.short_name==null||cicle.short_name==''">
                                    <p style="font-weight: 600;" v-if="cicle.name==null||cicle.name==''">
                                        {{ $t('without_cycle') }}
                                    </p>
                                    <p style="font-weight: 600;font-size: 12px;" v-else>
                                        {{cicle.name.slice(0,2).toUpperCase()}}
                                    </p>
                                </div>
                                <div v-else>
                                    <p style="font-weight: 600;">
                                        {{cicle.short_name}}
                                    </p>
                                </div>
                            </div>
                        </a>
                        <a
                            v-else
                            class="button-component cursor-pointer flex items-center justify-center p-2 mx-1"
                            :class="{
                                    'new_selected':cicle.cycle == select_cycle,
                                    'new_no_selected':cicle.cycle != select_cycle
                            }"
                            @click="fetchComponent(cicle.cycle,false)">
                            <div class="lg">
                                <div v-if="cicle.name==null||cicle.name==''">
                                    <p style="font-weight: 600;" v-if="cicle.short_name==null||cicle.short_name==''">
                                        {{ $t('without_cycle') }}
                                    </p>
                                    <p style="font-weight: 600;font-size: 12px;" v-else>
                                        {{cicle.name.slice(0,2).toUpperCase()}}
                                    </p>
                                </div>
                                <div v-else>
                                    <p style="font-weight: 600;">
                                        {{cicle.name}}
                                    </p>
                                </div>
                            </div>
                            <div class="xs">
                                <div v-if="cicle.short_name==null||cicle.short_name==''">
                                    <p style="font-weight: 600;" v-if="cicle.name==null||cicle.name==''">
                                        {{ $t('without_cycle') }}
                                    </p>
                                    <p style="font-weight: 600;font-size: 12px;" v-else>
                                        {{cicle.name.slice(0,2).toUpperCase()}}
                                    </p>
                                </div>
                                <div v-else>
                                    <p style="font-weight: 600;">
                                        {{cicle.short_name}}
                                    </p>
                                </div>
                            </div>
                        </a>
                    </template>
                </div>
            </div>
        </vs-col>
    </div>
</template>


<script>
import { mapGetters } from 'vuex';
import CycleMixin from './DisList/CycleMixin.vue'

export default {
    name:'Cycles',
    mixins:[CycleMixin],
    data() {
        return {
            thisFalse:false,
            thisTrue:true,

        }
    },
    computed:{
        ...mapGetters({
            cicles:'regis_discepline/getCicle',
            filter:'regis_discepline/getFilter',
            select_cycle:'regis_discepline/getSelectCycle',
        }),
        is_edvisor(){
            return this.$store.state.user.user.role.is_supervisor
        },
    },
    created() {
        // console.log(this.cicles)
    }


}
</script>


<style lang="css" scoped>

.selected{
    background: rgba(var(--vs-primary), 1) !important;
    color:white;
}
@media (max-width: 1024px){
    .lg{
        display: none;
    }
}
@media (max-width: 1024px){
    .xs{
        display: contents;
    }
}
.button-component{
    font-weight: 500;
}
.new_selected{
    transition-duration: 5s;
    color: rgb(84,93,167);
    transition-property: all;
    transition-delay: 0s;
    transition-timing-function: linear;
    transition: stroke-dashoffset 4s, stroke-dasharray 4s;
    border-bottom: 1px solid rgb(84,93,167);
}
.new_no_selected{
    color: rgb(99,99,99);
}
.new_no_selected:hover{
    transition-duration: 1s;
    color: rgb(84,93,167);
}



</style>
